import { axios } from 'app/App';
import { showMessage } from 'app/store/actions/fuse';
import i18n from 'i18next';

require('dotenv').config();

export const RESET_DASHBOARD_NEWS = '[CONSOLE] RESET_DASHBOARD_NEWS';
export const GET_DASHBOARD_NEWS = '[CONSOLE] GET NEWS';
export const GET_DASHBOARD_NEWS_UNIT = '[CONSOLE] GET NEWS UNIT';
export const SET_NEWS_ID_PRINT = '[CONSOLE] SET_NEWS_ID_PRINT';

export function resetDashboardNews() {
  return {
    type: RESET_DASHBOARD_NEWS
  };
}

export function getDashboardNews(status) {
  const request = axios.get(`/dashboard/news?status=${status}`, {});
  return dispatch =>
    request.then(response => {
      dispatch({
        type: GET_DASHBOARD_NEWS,
        payload: response.data
      });
    });
}

export function getDashboardPaginatedNews(status, page, perPage) {
  const request = axios.get(`/dashboard/news/light?status=${status}&page=${page}&perPage=${perPage ?? 10}`, {});
  return dispatch =>
    request.then(response => {
      dispatch({
        type: GET_DASHBOARD_NEWS,
        payload: response.data
      });
    });
}
export function getDashboardNewsUnit(id) {
  const request = axios.get(`/dashboard/news/${id}`, {});
  return dispatch =>
    request.then(response => {
      dispatch({
        type: GET_DASHBOARD_NEWS_UNIT,
        payload: response.data
      });
    });
}

export function setPrintNewsId(news_id_print) {
  return {
    type: SET_NEWS_ID_PRINT,
    news_id_print
  };
}

export function deleteNews(id, navigate) {
  const request = axios.delete(`/dashboard/news/${id}`, {});
  return dispatch =>
    request
      .then(response => {
        dispatch(
          showMessage({ message: i18n.t('action.delation.deletion_success') })
        );
        dispatch(getDashboardNews());
        navigate('/dashboard/news');
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}

export function updateNews(data, id) {
  const request = axios.put(`/dashboard/news/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return dispatch =>
    request
      .then(response => {
        dispatch(
          showMessage({ message: i18n.t('action.modify.modify_success') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}

export function createNews(data, navigate) {
  const request = axios.post('/dashboard/news', data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return dispatch =>
    request
      .then(response => {
        dispatch(
          showMessage({ message: i18n.t('action.creation.creation_success') })
        );
        navigate('/dashboard/news');
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}

export function deleteImage(id) {
  const request = axios.delete(`/dashboard/news/image/${id}`, {});
  return dispatch =>
    request
      .then(response => {
        dispatch(
          showMessage({
            message: i18n.t('action.delation.success_message_updated_f', {
              entity: i18n.t('image')
            })
          })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}
